'use client'

import type { AddedToCartNotificationProps } from '@maestro/commerce-blocks/components/cart/cart.types'

import { useTranslations } from 'next-intl'

import { useAddedToCartNotification } from '@maestro/commerce-blocks/components/cart/batons/use-added-to-cart-notification'
import { ProductPrice } from '@maestro/commerce-blocks/components/product-price'
import { Button } from '@pearlconvert/ui/components/button'

const AddedToCartNotification = (props: AddedToCartNotificationProps) => {
  const { productCount, totalPrice } = props
  const {
    cartUrl,
    handleOpenCartModal,
    isSlidein,
    isVisibleActionButton,
    notificationRef,
  } = useAddedToCartNotification()
  const t = useTranslations('commerce-blocks')

  return (
    <div className={'toast-addtocart__content'} ref={notificationRef}>
      <div className="toast-addtocart__info">
        <span className="toast-addtocart__text">
          {t('cart.total-products-count', { count: productCount })}
        </span>
        <span className="toast-addtocart__price">
          <ProductPrice price={totalPrice} />
        </span>
      </div>
      {isVisibleActionButton ? (
        isSlidein ? (
          <Button
            iconRight="arrow-right"
            type="primary"
            className={'toast-addtocart__button'}
            onClick={handleOpenCartModal}
          >
            {t('cart.show')}
          </Button>
        ) : (
          <Button
            iconRight="arrow-right"
            type="primary"
            className={'toast-addtocart__button'}
            url={cartUrl}
          >
            {t('cart.to-cart')}
          </Button>
        )
      ) : null}
    </div>
  )
}

export default AddedToCartNotification
